"use strict";
exports.__esModule = true;
exports.useToggleContext = exports.ToggleContainer = void 0;
var ToggleContainer_1 = require("./ToggleContainer");
var ToggleContent_1 = require("./ToggleContent");
var ToggleContext_1 = require("./ToggleContext");
exports.useToggleContext = ToggleContext_1.useToggleContext;
var ToggleTrigger_1 = require("./ToggleTrigger");
var ToggleContainer = Object.assign(ToggleContainer_1.ToggleContainer, {
    Content: ToggleContent_1.ToggleContent,
    Trigger: ToggleTrigger_1.ToggleTrigger,
    AnimatedContent: ToggleContainer_1.AnimatedToggleContent,
    CloseOnClickOutside: ToggleContainer_1.CloseOnClickOutside
});
exports.ToggleContainer = ToggleContainer;
//# sourceMappingURL=index.js.map